import React from 'react';
import './App.css';
import { BrowserRouter, Route} from "react-router-dom";
import HomePage from './components/home/HomePage';
import Navigation from './components/partials/Navigation';
import NewsletterForm from './components/partials/NewsletterForm';
import Somos from './components/partials/Somos';
import FooterApp from './components/partials/FooterApp';
import ProvidersList from './components/provider/ProvidersList';
import VideoList from './components/video/VideoList';
import VideoListProv from './components/video/VideoListProv';
import ProductsList from './components/product/ProductsList';
import AllItems from './components/product/AllItems';
import CategoriesItem from './components/product/CategoriesItem';
import SubcatesCategory from './components/product/SubcatesCategory';
import ProviderDetails from './components/provider/ProviderDetails';
import VideoDetails from './components/video/VideoDetails';
import ProductDetails from './components/product/ProductDetails';
import PostsList from './components/posts/PostsList';
import PostDetails from './components/posts/PostDetails';
import SearchResults from './components/home/SearchResults';

import Contact from './components/home/Contact';
import Advertise from './components/home/Adverstise';

import Shopping from './components/home/shopping';

import Login from './components/user/login';
import Register from './components/user/register';

import Perfil from './components/profile/perfil';
import Pedidos from './components/profile/pedidos';
import Productos_pe from './components/profile/productos.js';

// BIM

import AllBim from './components/bim/AllBim';
import CategoriesBim from './components/bim/CategoriesBim';
import SubcatesCategoryBim from './components/bim/SubcatesCategoryBim';
import BimList from './components/bim/BimList';
import BimFormat from './components/bim/BimFormat';

class App extends React.Component{
   
   

    render(){
        return ( 
            <div>
                <BrowserRouter>
                    <Navigation/>   
                    <br></br><br></br><br></br>
                    <main className="mainwrapper">
                        
                        <Route exact path="/" component={HomePage}/>
                        <Route path="/somos" component={Somos}/>
                        <Route path="/empresas" component={ProvidersList}/>
                        <Route exact path="/productos" component={AllItems}/>
                        <Route exact path="/productos/:item" component={CategoriesItem}/>
                        <Route exact path="/productos/:item/:category" component={SubcatesCategory}/>
                        <Route exact path="/productos/:item/:category/:subcate" component={ProductsList}/>
                        <Route exact path="/empresa/:provider" component={ProviderDetails}/>
                        <Route path="/producto/:product" component={ProductDetails}/>
                        <Route path="/noticias" component={PostsList}/>
                        <Route exact path="/noticia/:noticia" component={PostDetails}/>
                        <Route exact path="/buscar/:text" component={SearchResults}/>
                        <Route path='/contacto'  component={Contact}/>
                        <Route path='/publicidad' component={Advertise}/>
                        <Route path='/videos' component={VideoList}/>
                        <Route exact path="/video/:video" component={VideoDetails}/>

                        <Route exact path="/empresa-videos/:video" component={VideoListProv}/>

                        <Route path='/shoppingcart' component={Shopping}/>

                        <Route path='/login' component={Login}/>
                        <Route path='/register' component={Register}/>
                        <Route path='/user/perfil' component={Perfil}/>
                        <Route path='/user/pedidos' component={Pedidos}/>
                        <Route path='/user/productos/:product' component={Productos_pe}/>

                        
                        <Route exact path="/bim" component={AllBim}/>
                        <Route exact path="/bim/:item" component={CategoriesBim}/>
                        <Route exact path="/bim/:item/:category" component={SubcatesCategoryBim}/>
                        <Route exact path="/bim/:item/:category/:subcate" component={BimList}/>

                        <Route exact path="/bim-format/:format" component={BimFormat}/>


                        <NewsletterForm/>
                    </main>
                    <FooterApp/>
                </BrowserRouter>
            </div>
        )
    }
}

export default App;